/**
 * Day key for an API DateOnly value. DateOnly fields deserialize as UTC-midnight Dates, so the key
 * must come from the UTC date part — local formatting would shift it to the previous day in
 * behind-UTC (UTC−) timezones.
 */
export function dateOnlyKey(date: Date): string {
  return date.toISOString().slice(0, 10);
}

/**
 * Rebuilds an API DateOnly value as a local-midnight Date, so date-fns formatting shows the day the
 * backend meant regardless of the browser timezone.
 */
export function dateOnlyToLocalDate(date: Date): Date {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}
